export const dateMap = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

export const EXHUT_DELIVERY_LOCAL_STORAGE_TOKEN = "exhut-delivery-web-token";
export const EXHUT_DELIVERY_REDIRECT = "exhut-delivery-redirect-url";
export const EXHUT_DELIVERY_LOCAL_STORAGE_LAT = "exhut-delivery-web-lat";
export const EXHUT_DELIVERY_LOCAL_STORAGE_LNG = "exhut-delivery-web-lng";

export enum ROUTES {
  DASHBOARD = "/dashboard",
  HOME = "/home",
  BASE = "/",
  REGISTER = "/register",
  LOGIN = "/login",
  ADMIN = "/admin",
  jobs = "",
  register = "/register",
  forgotPassword = "/forgot-password",
}

export function getSubscription(entitlement: string | number | undefined) {
  if (entitlement) {
    switch (entitlement) {
      case 0:
        return "TRIAL";
      case 1:
        return "BASIC";
      case 2:
        return "STANDARD";
      case 3:
        return "PREMIUM";
      case 10:
        return "UNLIMITED";
    }
  } else {
    return "TRIAL";
  }
}

enum Countries {
  AUS = "AUS",
  BW = "BW",
  CAN = "CAN",
  CHN = "CHN",
  IND = "IND",
  SGP = "SGP",
  UK = "UK",
  USA = "USA",
}

export enum COUNTRY_CODE {
  AUSTRALIA = "AUS",
  BRAZIL = "BRA",
  CANADA = "CAN",
  FRANCE = "FRA",
  INDIA = "IND",
  INDONESIA = "ID",
  MEXICO = "MX",
  SINGAPORE = "SGP",
  UK = "UK",
  USA = "USA",
}

export function getCountryPhoneCode(country?: string) {
  switch (country) {
    case Countries.AUS:
      return "+61";
    case Countries.BW:
      return "+267";
    case Countries.CAN:
      return "+1";
    case Countries.CHN:
      return "+86";
    case Countries.IND:
      return "+91";
    case Countries.SGP:
      return "+65";
    case Countries.UK:
      return "+44";
    case Countries.USA:
      return "+1";
    default:
      return "";
  }
}

export function getCountryFullName(countryCode?: string): string {
  switch (countryCode) {
    case Countries.AUS:
      return "Australia";
    case Countries.BW:
      return "Botswana";
    case Countries.CAN:
      return "Canada";
    case Countries.CHN:
      return "China";
    case Countries.IND:
      return "India";
    case Countries.SGP:
      return "Singapore";
    case Countries.UK:
      return "United Kingdom";
    case Countries.USA:
      return "United States Of America";
    default:
      return "";
  }
}

export const FeatureFlags = {
  ENABLE_BUSINESS: "enable-business",
  ENABLE_SUBSCRIPTIONS: "enable-subscriptions",
  ENABLE_BUSINESS_CUSTOMER_LOGIN: "enable-business-customer-login",
};
